import type { SurveyPage, SurveyQuestion } from '../../fetchSurvey/types';
import type { SurveyAnswers } from '../../submitSurvey/types';
import type { CustomFieldValueMap } from '../../surveyLogic/types/customFieldValues';
import { buildLogicContext } from '../../surveyLogic/context/buildLogicContext';
import { simulateActivePath } from './activePath';
import { getAnswerableQuestionsOnPage } from './earnedProgress';

export function computeActivePathQuestionNumbers(
  pages: SurveyPage[],
  values: SurveyAnswers,
  allQuestions: SurveyQuestion[],
  customFieldValues: CustomFieldValueMap = {}
): Map<string, number> {
  const logicContext = buildLogicContext(values, allQuestions, customFieldValues);
  const pathPages = simulateActivePath(pages, values, allQuestions, customFieldValues);
  const numbers = new Map<string, number>();
  let ordinal = 0;

  for (const pageIndex of pathPages) {
    const page = pages[pageIndex];
    if (!page) continue;

    for (const question of getAnswerableQuestionsOnPage(page, logicContext)) {
      ordinal += 1;
      numbers.set(question.id, ordinal);
    }
  }

  return numbers;
}

export function applyActivePathQuestionNumbers(
  questions: SurveyQuestion[],
  numbers: Map<string, number>
): SurveyQuestion[] {
  let changed = false;

  const resolved = questions.map(question => {
    const questionNumber = numbers.get(question.id);
    if (questionNumber === undefined) {
      if (question.questionNumber === undefined) {
        return question;
      }
      changed = true;
      return { ...question, questionNumber: undefined };
    }
    if (question.questionNumber === questionNumber) {
      return question;
    }
    changed = true;
    return { ...question, questionNumber };
  });

  return changed ? resolved : questions;
}
